import React, { useState, useEffect ,useRef} from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageOff } from 'lucide-react';
import {  faTrash,  faPencilAlt,  faTimes,  faChevronRight,
  faChevronLeft,  faSearch,  faExclamationTriangle,
  faSearchPlus,  faSearchMinus,  faImage, faBoxOpen} from "@fortawesome/free-solid-svg-icons";
import s from '../images/salzer.jpg';
import gm from '../images/gm.jpg';
import legrand from '../images/legrand.jpg';
import goldmedal from '../images/goldmedal1.jpg';
import ArrowLeft from "../images/ArrowLeft.png";
import Bucket from "../images/Gray_Bucket.png";
import { motion } from "framer-motion";
import useOutsideClick from "../Component/OutsideClick"; 





//  import constructionlogo from './Images/constructionlogo3.jpg';
 import materialimg from './Images/materialimg.png';
 import AI_icon from '../images/AI_icon.png';

const sampleVendors = [
  { id: "V001", name: "Legrand", category: "ElectricalWires", vendor_image: legrand },
  { id: "V002", name: "Gold Medal", category: "ElectricalWires", vendor_image: goldmedal },
  { id: "V003", name: "Salzer", category: "ElectricalWires", vendor_image: s },
  // { id: "V004", name: "Anchor", category: "ElectricalWires", vendor_image: anchor },
  { id: "V005", name: "GM", category: "ElectricalWires", vendor_image: gm },
];


const ReviewItemList = () => {
  const [showBottomSheet, setShowBottomSheet] = useState(false);
const editPopupRef = useRef(null);
const addPopupRef = useRef(null);
const deletePopupRef = useRef(null);
const warningPopupRef = useRef(null);

useOutsideClick(editPopupRef, () => setEditingItem(null));
useOutsideClick(addPopupRef, () => setShowAddPopup(false));
useOutsideClick(deletePopupRef, () => setShowDeletePopup(false));
useOutsideClick(warningPopupRef, () => setShowWarningPopup(false));

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {mrId} = location.state || {};

const { materialItemId } = location.state || {};

const [showVendorPopup, setShowVendorPopup] = useState(false);
const [selectedVendors, setSelectedVendors] = useState([]);
const inputRef = useRef(null);
const [uoms, setUoms] = useState([]);
const [allProducts, setAllProducts] = useState([]); // fetched products
const [editingItem, setEditingItem] = useState(null);
const [isInputFocused, setIsInputFocused] = useState(false);
const [preventSuggestions, setPreventSuggestions] = useState(false);
const [mrData, setMrData] = useState(null);
const MRID = mrData?.material_requirement_id;
const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [loading, setLoading] = useState(true);
const [zoom, setZoom] = useState(1);

const handleZoomIn = () => setZoom((z) => Math.min(z + 0.3, 3));
const handleZoomOut = () => setZoom((z) => Math.max(z - 0.3, 1));
const handleResetZoom = () => setZoom(1);
const images = mrData?.material_requirement_id?.material_list_attachments || [];
const [showAddPopup, setShowAddPopup] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [suggestedItems, setSuggestedItems] = useState([]);
const [selectedItems, setSelectedItems] = useState([]);

const [bucketItems, setBucketItems] = useState(
  JSON.parse(localStorage.getItem("bucketItems") || "[]")
);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
const [itemToDelete, setItemToDelete] = useState(null);
const qtyInputRef = useRef(null);
const isQtyFocused = useRef(false);
const lastValidQty = useRef(0);
const qtyCleared = useRef(false);         
const hasEnteredNewQty = useRef(false);

const handlePrev = () =>
  setCurrentIndex((i) => (i > 0 ? i - 1 : images.length - 1));
const handleNext = () =>
  setCurrentIndex((i) => (i < images.length - 1 ? i + 1 : 0));

  useEffect(() => {
    fetchAllItems();
    getUoms();
  }, []);

    useEffect(() => {
    fetchMrItemsById();
  }, [materialItemId]);



  // 🔥 Detect mobile keypad close – restore previous qty
useEffect(() => {
  if (!window.visualViewport) return;

  let lastHeight = window.visualViewport.height;

  const handleResize = () => {
    const newHeight = window.visualViewport.height;

    // Keyboard closed → viewport height increases
    if (newHeight > lastHeight + 50 && isQtyFocused.current) {
      const restored = String(lastValidQty.current);

      // Restore previous correct qty
      setEditingItem(prev => ({
        ...prev,
        qty: restored
      }));

      qtyInputRef.current?.blur();
      isQtyFocused.current = false;
    }

    lastHeight = newHeight;
  };

  window.visualViewport.addEventListener("resize", handleResize);

  return () =>
    window.visualViewport.removeEventListener("resize", handleResize);
}, []);


const fetchAllItems = async () => {
  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');
    const organizationId = sessionStorage.getItem('organizationId'); 
 
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-all-products?organization_id=${organizationId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

   const data = await response.json();
   ///console.log('Fetched products:', data);
      if (data.success && data.data) {
        setAllProducts(data.data);
      }
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
  finally {
    setLoading(false);
  }
};

const fetchMrItemsById = async ( ) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/get-mritems-by-id?_id=${materialItemId}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });
    const responseData = await response.json();
    console.log('Fetched MR Items by ID:', responseData);
    if (response.ok && responseData.data) {
      setMrData(responseData.data);
    } else {
      console.error('Failed to fetch MR Items by ID:', responseData.message);
      return null;
    }
  } catch (error) {
    console.error('Error fetching MR Items by ID:', error);
    return null;
  }
};


const getUoms = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      }
    });
    
    const responseData = await response.json();
    //console.log('Fetched UOMs:', responseData);

    if (response.ok && responseData.data) {
      // Set fetched UOMs to state
      setUoms(responseData.data.map(u => ({ _id: u._id, UOM: u.UOM })));
    } else {
      console.error('Failed to fetch UOMs:', responseData.message);
    }
  } catch (error) {
    console.error('Error fetching UOMs:', error);
  }
};



useEffect(() => {
  if (showBottomSheet) {
    // ✅ Allow background scroll while popup is open
    document.body.style.overflowY = "auto";
  } else {
    // ✅ Restore normal when popup closed
    document.body.style.overflowY = "";
  }
  return () => {
    document.body.style.overflowY = "";
  };
}, [showBottomSheet]);


  useEffect(() => {
  if (showAddPopup) {
    setSearchTerm("");
    setSuggestedItems([]);
  } 
}, [showAddPopup]);


  const handleDelete = (item) => {
  setItemToDelete(item);
  setShowDeletePopup(true);
};

   const toggleVendorSelection = (vendorId) => {
    if (selectedVendors.includes(vendorId)) {
      setSelectedVendors(selectedVendors.filter((id) => id !== vendorId));
    } else {
      setSelectedVendors([...selectedVendors, vendorId]);
    }
  };


  const confirmDelete = async () => {
  if (!itemToDelete || !mrData) return;

  const token = sessionStorage.getItem("token");

  // Filter out the deleted item
  const updatedItemsArray = mrData.items.filter((item) => item._id !== itemToDelete._id);

  // Update category IDs if needed (remove categories that are no longer present)
  const updatedCategoryIds = Array.from(
    new Set([
      ...(mrData.product_category_ids || []).map(c =>
        typeof c === "string" ? c : c?._id || c
      ),
      ...updatedItemsArray
        .map((item) => item.product_id?.product_category_id)
        .filter(Boolean),
    ])
  ).filter(Boolean);

  const updatedData = {
    MRId: mrData?.material_requirement_id?._id,
    MR_items: {
      _id: mrData._id,
      material_requirement_id: mrData.material_requirement_id,
      price_eligibility: mrData.price_eligibility,
      product_category_ids: updatedCategoryIds,
      rfq_number: mrData.rfq_number,
      vendor_ids: mrData.vendor_ids || [],
      items: updatedItemsArray.map((item) => ({
        _id: item._id,
        product_id: item.product_id
          ? {
              _id: item.product_id._id,
              product_category_id: item.product_id.product_category_id,
              product_name: item.product_id.product_name,
              product_image: item.product_id.product_image,
              selling_price: item.product_id.selling_price,
            }
          : null,
        product_name: item.product_name,
        quantity: item.quantity,
        UOM_id: item.UOM_id
          ? {
              _id: item.UOM_id._id,
              UOM: item.UOM_id.UOM,
            }
          : null,
        is_available: item.is_available,
        item_available: item.item_available,
      })),
    },
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/update-material-requirement-items`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(updatedData),
      }
    );

    const responseData = await response.json();

    if (response.ok && responseData.success) {
      fetchMrItemsById(); // Refresh the data
      setShowDeletePopup(false);
      setItemToDelete(null);
    } else {
      alert(responseData.message || "Failed to delete item");
    }
  } catch (error) {
    console.error("Error deleting item:", error);
    alert("Something went wrong while deleting the item");
  }
};


// Handle image file change
const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (ev) => {
      setEditingItem(prev => ({ ...prev, image: ev.target.result }));
    };
    reader.readAsDataURL(file);
  }
};

// Save updated item and call backend
const handleSave = async () => {
  if (!editingItem || !mrData) return;

  const token = sessionStorage.getItem("token");

  const selectedProduct = allProducts.find(p => p._id === editingItem.product_id);

  const selectedCategoryId =
    selectedProduct?.product_category_id ||
    editingItem.product_category_id ||
    null;

  const currentUOM = uoms.find(u => u.UOM === editingItem.uom);
  const uomIdToSend =
    editingItem.UOM_id?._id ||
    editingItem.UOM_id ||
    (currentUOM ? currentUOM._id : null);

  const cleanImagePath = (url) => {
    if (!url) return null;
    return url.replace(/^https?:\/\/[^/]+\/uploads\//, '').replace(/^uploads\//, '');
  };

  const updatedItemsArray = mrData.items.map((item) => {
    if (item._id === editingItem._id) {
      return {
        _id: editingItem._id, 

      
        product_id: {
          _id:
            editingItem.product_id ||
            selectedProduct?._id ||
            item.product_id?._id,
          product_category_id:
            selectedCategoryId ||
            item.product_id?.product_category_id ||
            null,
          product_name:
            editingItem.name ||
            selectedProduct?.product_name ||
            item.product_name,
          product_image:
            cleanImagePath(editingItem.image) ||
            item.product_id?.product_image,
          selling_price:
            selectedProduct?.selling_price ||
            item.product_id?.selling_price ||
            0,
        },

      
        product_name:
          editingItem.name ||
          selectedProduct?.product_name ||
          item.product_name,

        quantity: Number(editingItem.qty ?? item.quantity),

    
        UOM_id: {
          _id: uomIdToSend || item.UOM_id?._id,
          UOM: editingItem.uom || item.UOM_id?.UOM,
        },

        is_available: true,
        item_available: true,
      };
    }

    
    return {
      ...item,
      product_id: item.product_id
        ? {
            _id: item.product_id._id,
            product_category_id: item.product_id.product_category_id,
            product_name: item.product_id.product_name,
            product_image: item.product_id.product_image,
            selling_price: item.product_id.selling_price,
          }
        : null,
      UOM_id: item.UOM_id
        ? {
            _id: item.UOM_id._id,
            UOM: item.UOM_id.UOM,
          }
        : null,
    };
  });

  
  const updatedCategoryIds = Array.from(
    new Set([
      ...(mrData.product_category_ids || []).map(c =>
        typeof c === "string" ? c : c?._id || c
      ),
      ...(selectedCategoryId ? [selectedCategoryId] : []),
    ])
  ).filter(Boolean);

  const updatedData = {
    MRId: mrData?.material_requirement_id?._id,
    MR_items: {
      _id: mrData._id,
      material_requirement_id: mrData.material_requirement_id,
      price_eligibility: mrData.price_eligibility,
      product_category_ids: updatedCategoryIds, 
      rfq_number: mrData.rfq_number,
      vendor_ids: mrData.vendor_ids || [],
      items: updatedItemsArray, 
    },
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/update-material-requirement-items`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(updatedData),
      }
    );

    const responseData = await response.json();

    if (response.ok && responseData.success) {
      fetchMrItemsById();
      setEditingItem(null);
    } else {
      alert(responseData.message || "Failed to update item");
    }
  } catch (error) {
    console.error("❌ Error updating MR Items:", error);
    alert("Something went wrong while updating MR Items");
  }
};


  const handleEditClick = (item) => {
  const editedData = {
    _id: item._id, 
    product_id: item.product_id?._id, 
    UOM_id: item.UOM_id?._id, 
    
    name: item.product_name || "",
     originalName: item.product_name || "", 
    uom: item.UOM_id?.UOM || "",
    price: item.product_id?.selling_price || 0,
    image: item.product_id?.product_image
      ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_id.product_image}`
      : "/placeholder.jpg",
    qty: item.quantity || 0,
  };
 lastValidQty.current = item.quantity ?? 1;
qtyCleared.current = false;
hasEnteredNewQty.current = false;
  setEditingItem(editedData);
  setShowSuggestions(false); // ✅ Prevent suggestions from showing when popup opens
  setSuggestions([]); // ✅ Clear any existing suggestions
  requestAnimationFrame(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  });
};

  const handleClose = () => {
    setEditingItem(null);
  };

  const handleChange = (field, value) => {
    setEditingItem((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  
const handleSubmit = (e) => {
  e.preventDefault();
};

 const handleViewBucket = () => {
      navigate('/consumer/cartpreview', { state: { } });
    };
  

const handleAddToBucket = () => {
  if (!mrData || !mrData.items) return;

 const existing = localStorage.getItem("bucketProducts");
if (existing && Object.keys(JSON.parse(existing)).length > 0) {
  setShowWarningPopup(true);
  return;
}

  // 🟢 Filter only available items
  const availableItems = mrData.items.filter(
    (item) => item.is_available === true || item.item_available === true
  );

  if (availableItems.length === 0) {
    alert("No available items to add to the bucket.");
    return;
  }

  // Convert to object format with _id as keys
  const bucketItems = {};
  
  availableItems.forEach((item) => {

    const itemId = item?.product_id?._id || null;
    
    bucketItems[itemId] = {
      _id: itemId,
      product_group_id: item.product_group_id || null,
      vendor_id: item.vendor_id || item.product_id?.vendor_id || "",
      product_category_id: 
        item.product_category?._id ||
        item.product_id?.product_category_id ||
        null,
      product_sub_category_id: 
        item.product_sub_category_id ||
        item.product_sub_category?._id ||
        item.product_id?.product_sub_category_id ||
        null,
      product_name: 
        item.product_name || 
        item.product_id?.product_name || 
        "",
      product_image: 
        item.product_image ||
        item.product_id?.product_image ||
        "",
      product_description: 
        item.product_description || 
        item.product_id?.product_description || 
        "",
      selling_price: 
        item.selling_price ||
        item.product_id?.selling_price ||
        0,
      UOM_id: 
        item.UOM_id || 
        item.product_id?.UOM_id || 
        "",
      specifications: 
        item.specifications || 
        item.product_id?.specifications || 
        "[]",
      tax_preference: 
        item.tax_preference || 
        item.product_id?.tax_preference || 
        "",
      GST: 
        item.GST || 
        item.product_id?.GST || 
        0,
      IGST: 
        item.IGST || 
        item.product_id?.IGST || 
        0,
      SKU: 
        item.SKU || 
        item.product_id?.SKU || 
        "",
      HSN_Code: 
        item.HSN_Code || 
        item.product_id?.HSN_Code || 
        "",
      cost_price: 
        item.cost_price || 
        item.product_id?.cost_price || 
        0,
      organizationIds: 
        item.organizationIds || 
        item.product_id?.organizationIds || 
        [],
      is_active: item.is_active !== undefined ? item.is_active : true,
      __v: item.__v || 0,
      quantity: item.quantity || item.qty || 1
    };
  });

  localStorage.setItem("bucketProducts", JSON.stringify(bucketItems));
  const customer = JSON.parse(sessionStorage.getItem("userData"));

const material_requirement = {
  customer_id: customer?._id,
  material_requirement_id: mrData?.material_requirement_id,
  MR_items_id: mrData._id
};

localStorage.setItem("material_requirement", JSON.stringify(material_requirement));

  window.location.href = "/consumer/cartpreview";
};

 const handleNameChange = (e) => {
  const value = e.target.value;
  setEditingItem(prev => ({ ...prev, name: value, priceChanged: false }));

  if (value.length > 0) {
    const filtered = allProducts.filter(p =>
      p.product_name.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filtered);           // all partial matches
    setShowSuggestions(filtered.length > 0);
  } else {
    setShowSuggestions(false);
  }
};

const handleAddItems = async () => {
  if (!mrData || selectedItems.length === 0) return;

  console.log("🟢 handleAddItems() called");

  const token = sessionStorage.getItem("token");

  // 🧩 Merge existing + new selected items
  const existingIds = new Set(
    (mrData.items || []).map(
      (item) => item?.product_id?._id?.toString() || item?._id?.toString()
    )
  );

  const newItems = selectedItems
    .filter((item) => !existingIds.has(item._id?.toString()))
    .map((item) => ({
      product_id: {
        _id: item._id, // product ID
        product_category_id: item.product_category_id || null,
        product_name: item.product_name,
        product_image: item.product_image,
        selling_price: item.selling_price || 0,
      },
      product_name: item.product_name,
      quantity: Number(item.qty || 1),
      UOM_id: {
        _id: item.UOM_id?._id || null,
        UOM: item.UOM_id?.UOM || "Nos",
      },
      is_available: true,
      item_available: true,
    }));

  const updatedItemsArray = [...(mrData.items || []), ...newItems];

  const updatedCategoryIds = Array.from(
    new Set([
      ...(mrData.product_category_ids || []).map((c) =>
        typeof c === "string" ? c : c?._id || c
      ),
      ...selectedItems
        .map((i) => i.product_category_id)
        .filter((id) => id),
    ])
  );

  // ✅ Corrected Payload — no "MRId" outside
  const updatedData = {
  MRId: mrData?.material_requirement_id?._id, // ✅ Only send the string
    MR_items: {
      _id: mrData._id,
      material_requirement_id: mrData.material_requirement_id,
      price_eligibility: mrData.price_eligibility,
      product_category_ids: updatedCategoryIds,
      rfq_number: mrData.rfq_number,
      vendor_ids: mrData.vendor_ids || [],
      items: updatedItemsArray,
    },
  };
  

  // 🟡 Debug logs
  console.log("🧾 Sending MR Items Update Request");
  console.log("Material Requirement ID:", mrData.material_requirement_id);
  console.log("Items being sent:", updatedItemsArray);
  console.log("Payload:", updatedData);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/material-requirement/update-material-requirement-items`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(updatedData),
      }
    );

    const responseData = await response.json();
    console.log("✅ Backend Response:", responseData);

    if (response.ok && responseData.success) {
      setShowAddPopup(false);
      setSelectedItems([]);
      await fetchMrItemsById(); // refresh
      console.log("🔄 MR items refreshed successfully");
    } else {
      console.warn("⚠️ MR items update failed:", responseData.message);
      alert(responseData.message || "Failed to update MR items");
    }
  } catch (error) {
    console.error("❌ Error updating MR items:", error);
    alert("Something went wrong while adding new items");
  }
};

const handleProductClick = (item) => {
  const productData = item.product_id
    ? {
        _id: item.product_id._id,
        product_name: item.product_id.product_name,
        product_image: item.product_id.product_image,
        product_description: item.product_id.product_description || "",
        selling_price: item.product_id.selling_price,
        UOM_id: item.UOM_id,
        specifications: item.product_id.specifications || "[]",
        tax_preference: item.product_id.tax_preference || "",
        GST: item.product_id.GST || 0,
        IGST: item.product_id.IGST || 0,
        SKU: item.product_id.SKU || "",
        HSN_Code: item.product_id.HSN_Code || "",
        cost_price: item.product_id.cost_price || 0,
        organizationIds: item.product_id.organizationIds || [],
        is_active:
          item.product_id.is_active !== undefined
            ? item.product_id.is_active
            : true,
        vendor_id: item.product_id.vendor_id || "",
        product_category_id: item.product_id.product_category_id || "",
      }
    : null;

  console.log("🟢 Navigating to ProductInformation with:", productData);

  navigate("/consumer/productInformation", {
    state: {
      product: productData,
      vendor_id: productData?.vendor_id,
      relatedProducts: [],
    },
  });
};



if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading Items...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 pb-6">
      {/* Header Section */}
{/* Header */}
<div className="bg-white border-b border-gray-300 px-1 py-2 flex items-center justify-between sticky top-0 z-30 h-14">
  {/* Left side: Back button and title */}
  <div className="flex items-center">
    <img
      src={ArrowLeft}
      className="text-gray-700 w-12 h-8 flex-shrink-0 cursor-pointer"
      onClick={() => navigate(-1)}
      alt="Back"
    />
    <div className="ml-1 flex flex-col">
      <h1 className="text-lg font-semibold text-gray-900">Review Items</h1>
      <p className="text-gray-500 text-xs font-medium">
        • {mrData?.items?.length || 0} items
      </p>
    </div>
  </div>

  {/* Right side: Cart icon with count */}
  <div
    className="relative mr-2 cursor-pointer flex items-center justify-center"
    onClick={handleViewBucket}
  >
    <img src={Bucket} alt="Bucket" className="h-8 w-8 object-contain" />
    {Object.keys(JSON.parse(localStorage.getItem("bucketProducts") || "{}")).length > 0 && (
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full h-4 w-4 flex items-center justify-center">
        {Object.keys(JSON.parse(localStorage.getItem("bucketProducts") || "{}")).length}
      </span>
    )}
  </div>
</div>

{/* ✅ Animated Note Section - hides when bottom sheet opens */}
{!showBottomSheet && (
  <motion.div
    initial={{ y: -60, opacity: 0 }}   // 👈 slide down from top
    animate={{ y: 0, opacity: 1 }}
    exit={{ y: -60, opacity: 0 }}
    transition={{ duration: 0.4, ease: "easeOut" }}
    className="bg-gradient-to-r from-white to-gray-50 p-3 my-2 rounded-r-md shadow-sm border border-gray-100 sticky top-14 z-20"
  >
    <div className="flex items-start gap-2">
      <div className="text-gray-800">
        <span className="text-blue-600 font-bold text-sm">NOTE :</span>{" "}
        <span className="font-semibold text-sm">
          The Prices shown below are{" "}
          <span className="font-bold">Estimates only</span>.{" "}
          <span className="font-bold">Add to Bucket</span> to get final and best price.
        </span>
      </div>
    </div>
  </motion.div>
)}





<div
  className="overflow-y-auto"
  style={{
    maxHeight: "calc(100vh - 60px)",
    paddingBottom: showBottomSheet ? "42vh" : "0", // ✅ gives full scroll space when popup open
  }}
> 





 {mrData && (
  <>
    {/* Category-based Items */}
{/* Flat List of Available Items */}
<div className="mx-3 mt-2 bg-white border border-gray-200 rounded-lg shadow-sm space-y-2">
{mrData.items
  .filter(
    (item) =>
      item.is_available === true &&
      item.product_category &&
      item.product_id &&
      item.product_category !== "" &&
      item.product_id !== ""
  )
  .map((item, index) => (
    <div
      key={item._id}
      className="border-b border-gray-300 p-3 flex items-start"
    >
      {/* Image */}
      <div
        className="w-14 h-14 border border-gray-200 rounded-md flex items-center justify-center overflow-hidden flex-shrink-0 bg-gray-100 cursor-pointer"
        onClick={() => handleProductClick(item)} // ✅ using shared function
      >
        {item.product_id?.product_image ? (
          <img
            src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_id.product_image}`}
            alt={item.product_name}
            className="w-12 h-12 object-contain"
            onError={(e) => {
              e.target.style.display = "none";
              const parent = e.target.parentNode;
              if (parent && !parent.querySelector(".no-img-text")) {
                const span = document.createElement("span");
                span.className =
                  "no-img-text text-gray-400 text-[10px] text-center";
                span.innerText = "No Image";
                parent.appendChild(span);
              }
            }}
          />
        ) : (
          <span className="text-gray-400 text-[10px] text-center">
            No Image
          </span>
        )}
      </div>

      {/* Details */}
      <div className="ml-3 flex justify-between items-start w-full">
        {/* Left Column: Name + Category */}
        <div className="flex flex-col w-[70%] pr-2">
          <p
            className="text-sm font-medium text-gray-800 leading-tight break-words cursor-pointer"
            onClick={() => handleProductClick(item)} // ✅ same handler reused
          >
            {item.product_name}
          </p>
          <p className="text-xs text-gray-500 mt-[2px] truncate">
            {item.product_category?.product_category_name || "Uncategorized"}
          </p>
        </div>

        {/* Right Column: Qty + Price + Icons */}
        <div className="flex flex-col items-end gap-1 w-[30%] flex-shrink-0">
          <div className="flex flex-col items-end text-right">
            <div className="flex items-center gap-1">
              <span className="text-xs font-medium text-gray-800">
                {item.quantity}
              </span>
              <span className="text-[10px] text-gray-600">
                {item.UOM_id?.UOM || "-"}
              </span>
            </div>
            <span className="text-sm font-semibold text-gray-800">
              ₹{item.product_id?.selling_price?.toLocaleString("en-IN") || 0}
              <span className="text-xs text-gray-500 ml-[1px]">
                /{item.UOM_id?.UOM || "-"}
              </span>
            </span>
            <p className="text-[11px] text-gray-500 font-medium whitespace-nowrap">
              Wrong Item?
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col items-center gap-2">
            <div className="flex flex-row">
              <span
                className="mr-1 w-5 h-5 flex items-center justify-center border border-gray-200 rounded-full cursor-pointer"
                onClick={() => handleEditClick(item)}
              >
                <FontAwesomeIcon
                  icon={faPencilAlt}
                  className="text-gray-600 text-[10px]"
                />
              </span>
              <span
                className="w-5 h-5 flex items-center justify-center border border-gray-200 rounded-full cursor-pointer"
                onClick={() => handleDelete(item)}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  className="text-gray-600 text-[10px]"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))}


</div>


  {/* 🟡 Show "Item Not Available" section only if any item has is_available === false */}
{mrData.items.some(item => item.is_available === false) && (
  <div className="mb-5 mx-3 bg-white border border-gray-300 rounded-lg mt-2">
    {/* Section Heading */}
    <div className="flex items-center justify-between py-1 border-b border-gray-200 bg-white mt-2">
      <div className="ml-3 flex flex-row justify-center items-center ">
         <img
        src={AI_icon}
        alt="AI"
        className="mb-3 w-6 h-6 object-cover"
      />
      <h2 className="ml-0.5 text-sm font-semibold text-gray-700 mb-2">
         is not able to find below items
      </h2>
      </div>
      {/* <span className="text-xs text-gray-500 font-medium mr-3 mb-2">
        Quantity
      </span> */}
    </div>

    {/* Items Wrapper */}
    <div className="p-2 space-y-3">
      {mrData.items
        .filter(item => item.is_available === false)
        .map((item, itemIndex) => (
          <div key={item._id}>
           <div className="flex items-center rounded-lg bg-white mx-1">
  {/* Image */}
  <div className="w-12 h-12 border border-gray-200 rounded-md flex items-center justify-center overflow-hidden flex-shrink-0">
    {item.product_id?.product_image ? (
      <img
        src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_id.product_image}`}
        alt={item.product_name}
        className="w-10 h-10 object-cover"
      />
    ) : (
      <ImageOff size={24} className="text-gray-400" />
    )}
  </div>

  {/* Item Details */}
  <div className="ml-3 flex-1 flex flex-col justify-center">
    <div className="flex flex-wrap items-center gap-2">
      <p className="text-sm text-gray-800 break-words flex-1">
        {item.product_name}
      </p>

      <span className="flex items-center gap-1 mr-4 flex-shrink-0">
        <span className="text-sm text-[#000000]">{item.quantity}</span>
        <span className="text-gray-600 text-xs">
          {item.UOM_id?.UOM || item.unit || " "}
        </span>
      </span>
    </div>
  </div>
</div>


            {/* Separator */}
            {itemIndex !==
              mrData.items.filter(i => i.is_available === false).length - 1 && (
              <div className="border-t border-gray-200 my-2 w-full"></div>
            )}
          </div>
        ))}
    </div>
  </div>
)}
{/* 🟢 Missing Items Section */}

<div className="mx-3 bg-white border border-gray-200 rounded-lg mt-2 shadow-sm mb-16 flex items-center justify-between px-4 py-3">
  {/* Left: logo + text */}
  <div className="flex items-center gap-3">
    {/* Logo */}
    <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-gray-100  overflow-hidden">
      <img
        src={materialimg}
        alt="Construction Logo"
        className="w-16 h-14 object-cover"
      />
    </div>

    {/* Text */}
    <div>
      <p className="text-sm font-semibold text-gray-800">Add any missing items? </p> 
    </div>
  </div>

  {/* Right: Add button */}
  <button
    onClick={() => setShowAddPopup(true)}
    className="px-2 py-1 text-sm font-medium bg-red-500 hover:bg-red-600 text-white rounded-lg shadow-sm transition-all active:scale-95"
  >
    + Add
  </button>
</div>






{/* )} */}

  </>
)}

</div>

      {/* Bottom Sticky Bar */}
 <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 px-4 py-2 z-20 flex items-center justify-between shadow-xl">
  <div
    className="flex items-center flex-1 cursor-pointer group"
    onClick={() => setShowBottomSheet(true)}
  >
    {images.length > 0 ? (
      <div className="relative">
        {/* NEW: Stronger, continuous glow/pulse for high visibility */}
        <div className="absolute -inset-0.5 rounded-xl bg-gradient-to-tr from-red-600 to-red-400 blur-sm opacity-60 animate-pulse transition-all duration-1000"></div>

        {/* Improved Image Styling */}
        <img
          src={`${process.env.REACT_APP_FORE_BRICKBUCKET}${images[0]}`}
          alt="preview"
          className="relative w-11 h-11 object-cover rounded-xl border-2 border-white transition-all duration-300 transform 
                     group-hover:scale-110 
                     group-active:scale-90 
                     group-hover:shadow-2xl group-hover:shadow-red-500/50 
                     group-active:shadow-inner" // Inner shadow on click for depth
        />

        {/* Subtle badge or marker to signal it's a "bucket" item */}
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600"></span>
        </span>
      </div>
    ) : (
      // Increased size for ImageOff placeholder
      <ImageOff size={48} className="text-gray-400" /> 
    )}

    <div className="ml-4"> {/* Increased margin for better spacing */}
      <span className="text-base font-bold text-gray-800">
        {mrData?.items?.length || 0} Items
      </span>
      <p className="text-xs text-gray-500 font-medium">Review & Add to Bucket</p>
    </div>
  </div>

  <button
    className="bg-red-600 text-white text-sm font-medium px-3 py-2 rounded-xl shadow-lg hover:bg-red-700 transition duration-200 transform hover:scale-[1.02]" // Larger, bolder button
    onClick={handleAddToBucket}
  >
    Add to Bucket
  </button>
</div>


 {showVendorPopup && (
  <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40">
    <div className="bg-white w-full max-w-md p-4 rounded-t-2xl flex flex-col gap-3 max-h-[60vh] overflow-y-auto">
      {/* Handle Line */}
      <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mb-2"></div>

      {/* Header */}
      <div className="flex justify-between items-center">
        <p className="text-gray-900 font-semibold text-md">Select Brands</p>
        <FontAwesomeIcon
          icon={faTimes}
          className="text-gray-600 text-sm cursor-pointer"
          onClick={() => setShowVendorPopup(false)}
        />
      </div>

      {/* Instruction Text below Header */}
      <p className="text-sm text-gray-500 mt-1 text-center">
        Choose your preferred brands below to get the best quotes for the Electrical Wires in your project.
      </p>

      {/* Vendor List */}
      <div className="grid grid-cols-3 gap-3 mt-2">
        {sampleVendors.map((vendor) => {
          const isSelected = selectedVendors.includes(vendor.id);
          return (
            <div
              key={vendor.id}
              className={`flex flex-col items-center cursor-pointer rounded-lg border p-2 ${
                isSelected ? "border-gray-600 bg-gray-100" : "border-gray-300"
              }`}
              onClick={() => toggleVendorSelection(vendor.id)}
            >
              {/* Image div */}
              <div className="w-20 h-16 overflow-hidden rounded-lg">
                <img
                  src={vendor.vendor_image}
                  alt={vendor.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Separate Name div below */}
              {/* <div className="mt-2">
                <p className="text-xs text-gray-700 text-center">{vendor.name}</p>
              </div> */}
            </div>
          );
        })}
      </div>

      {/* Submit Button */}
      <button
        className="bg-red-600 text-white font-semibold py-2 rounded-lg mt-3"
        onClick={handleSubmit}
      >
        Submit
      </button>
    </div>
  </div>
)}



 {showAddPopup && (
  <div className="fixed inset-0 bg-black/40 flex items-start justify-center z-50 pt-6 overflow-y-auto">
    <div 
    ref={addPopupRef}
    className="bg-white w-[96%] max-w-xl max-h-[90vh] flex flex-col shadow-2xl relative overflow-hidden">
      
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-800">Add Items</h2>
         <button
          onClick={() => setShowAddPopup(false)}
          className="text-gray-400 hover:text-gray-600 text-3xl"
        >
          &times;
        </button>
      </div>

      {/* Search Bar */}
      <div className="px-4 py-3 border-b border-gray-100">
        <div className="relative">
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
          />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => {
              const val = e.target.value;
              setSearchTerm(val);

              if (val.length > 1 && allProducts?.length > 0) {
                const filtered = allProducts
                  .filter(
                    (p) =>
                      p?.product_name &&
                      p.product_name.toLowerCase().includes(val.toLowerCase())
                  )
                  .slice(0, 10);
                setSuggestedItems(filtered);
              } else {
                setSuggestedItems([]);
              }
            }}
            placeholder="Search item name..."
            className="w-full border border-gray-300 rounded-lg pl-9 pr-8 py-2 text-sm focus:outline-none"
          />

          {/* Clear text */}
          {searchTerm && (
            <button
              onClick={() => {
                setSearchTerm("");
                setSuggestedItems([]);
              }}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs border border-gray-300 rounded-full w-4 h-4 flex items-center justify-center"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Content (auto height) */}
      <div className="px-4 py-3 overflow-y-auto">
        {/* Suggestions */}
        {searchTerm.length > 1 && suggestedItems.length > 0 ? (
          <div className="border border-gray-300 rounded-lg overflow-y-auto max-h-[250px]">
            {suggestedItems.map((item, i) => {
              const foundIndex = selectedItems.findIndex(
                (it) => it._id === item._id
              );
              const found = foundIndex > -1 ? selectedItems[foundIndex] : null;
              const showQty = found?.showQty;
              const isAlreadyInMR = mrData?.items?.some((mrItem) => mrItem.product_id?._id === item._id);

              return (
                <div
                  key={item._id || `sug-${i}`}
                  onClick={() => {
                    if (!found && !isAlreadyInMR) {
                      setSelectedItems((prev) => [
                        { ...item, qty: 1, showQty: false },
                        ...prev,
                      ]);
                    }
                  }}
                  className={`flex items-center justify-between px-3 py-2 border-b border-gray-100 last:border-none ${
                    isAlreadyInMR ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 cursor-pointer"
                  }`}
                >
                  {/* Image + Name + Price */}
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="w-10 h-10 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center flex-shrink-0">
                      {item.product_image ? (
                        <img
                          src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_image}`}
                          alt={item.product_name}
                          className="w-full h-full object-contain"
                        />
                      ) : (
                         <div className="flex flex-col items-center justify-center text-gray-400">
                          <FontAwesomeIcon icon={faImage} className="text-md " />
                           </div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className={`text-sm font-medium truncate ${isAlreadyInMR ? "text-gray-500" : "text-gray-800"}`}>
                        {item.product_name}
                      </p>
                      <p className="text-xs text-gray-500">
                        ₹{item.selling_price?.toLocaleString("en-IN") || 0}
                      </p>
                    </div>
                  </div>

                  {/* Add / Qty Buttons or Already Added Text */}
                  <div
                    className="flex items-center justify-end ml-2"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {isAlreadyInMR ? (
                      <span className="text-xs text-red-500 font-medium">Already added</span>
                    ) : !found || (!showQty && found) ? (
                      <button
                        onClick={() => {
                          if (!found) {
                            setSelectedItems((prev) => [
                              { ...item, qty: 1, showQty: true },
                              ...prev,
                            ]);
                          } else {
                            setSelectedItems((prev) =>
                              prev.map((it) =>
                                it._id === item._id
                                  ? { ...it, showQty: true }
                                  : it
                              )
                            );
                          }
                        }}
                        className="text-[11px] bg-red-500 hover:bg-red-600 text-white px-3 py-[4px] rounded-md shadow-sm"
                      >
                        Add
                      </button>
                    ) : (
<div className="flex items-center border border-gray-300 rounded-md overflow-hidden min-w-[20px] flex-shrink-0">
  {/* Decrease Button */}
  <button
    onClick={() =>
      setSelectedItems((prev) =>
        prev.map((it) =>
          it._id === item._id && it.qty > 1
            ? { ...it, qty: it.qty - 1 }
            : it
        )
      )
    }
    className="font-extrabold w-5 h-6 flex items-center justify-center text-red-500 text-sm"
  >
    −
  </button>

  <div className="h-4 w-px bg-gray-300"></div>

  {/* Quantity Display (as span, not input) */}
  <span className="px-auto mx-auto font-bold w-5 text-center text-sm text-gray-700">
    {found.qty}
  </span>

  <div className="h-4 w-px bg-gray-300"></div>

  {/* Increase Button */}
  <button
    onClick={() =>
      setSelectedItems((prev) =>
        prev.map((it) =>
          it._id === item._id
            ? { ...it, qty: it.qty + 1 }
            : it
        )
      )
    }
    className="font-extrabold w-5 h-6 flex items-center justify-center text-red-500 text-sm"
  >
    +
  </button>
</div>



                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : searchTerm.length > 1 && suggestedItems.length === 0 ? (
      <div className="flex flex-col items-center justify-center py-14 text-gray-500">
  <div className="relative w-20 h-20 mb-3 flex items-center justify-center">
    {/* Decorative background circle */}
    <div className="absolute inset-0 bg-red-50 rounded-full animate-pulse" />
    
    {/* Icon */}
    <div className="relative z-10 flex items-center justify-center w-12 h-12 rounded-full bg-white shadow-md border border-gray-100">
      <FontAwesomeIcon
        icon={faSearch}
        className="text-xl text-red-500"
      />
    </div>
  </div>

  {/* Text */}
  <p className="text-sm font-medium text-gray-700 text-center">
    No matching items found
  </p>
  <p className="text-xs text-gray-400 text-center mt-1 leading-snug">
    Try adjusting your search or using different keywords.
  </p>
</div>


        ) : searchTerm.length === 0 && selectedItems.length === 0 ? (
          <div className="flex flex-col items-center justify-start mt-10 mb-12 text-gray-400 space-y-2">
            <FontAwesomeIcon
              icon={faSearch}
              className="text-xl text-red-400 animate-pulse"
            />
            <p className="text-sm text-gray-500 font-medium text-center leading-tight">
              Start typing to search for items...
            </p>
            <p className="text-xs text-gray-400 text-center"> Find and add materials quickly. </p>
          </div>
        ) : null}

        {/* Added Items */}
   {selectedItems.length > 0 && (
  <div className="mt-3">
    <div className="flex gap-3 overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden pb-3 px-1">
      {selectedItems.map((item, idx) => (
        <div
          key={item._id || `sel-${idx}`}
          className="relative flex-shrink-0 w-[140px] bg-white border border-gray-200 rounded-xl shadow-sm p-3 flex flex-col items-center"
        >
          {/* Image Box */}
          <div className="relative h-[100px] w-[100px] rounded-lg overflow-hidden shadow-sm flex items-center justify-center mb-2 bg-gray-50">
            {item.product_image ? (
              <img
                src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.product_image}`}
                alt={item.product_name}
                className="w-full h-full object-contain"
              />
            ) : (
              <span className="text-gray-400 text-[10px]">No Image</span>
            )}

            {/* Overlay: Add / Qty Controls */}
            <div className="absolute bottom-2 right-2">
              {!item.showQty ? (
                <button
                  onClick={() =>
                    setSelectedItems((prev) =>
                      prev.map((it) =>
                        it._id === item._id ? { ...it, showQty: true } : it
                      )
                    )
                  }
                  className="bg-red-500 hover:bg-red-600 text-white text-[10px] font-medium px-2 py-[2px] rounded-md shadow-md"
                >
                  ADD
                </button>
              ) : (
                <div className="flex items-center bg-red-500 text-white rounded-md px-1 py-[1px] shadow-md">
                  <button
                    onClick={() =>
                      setSelectedItems((prev) =>
                        prev.map((it) =>
                          it._id === item._id && it.qty > 1
                            ? { ...it, qty: it.qty - 1 }
                            : it
                        )
                      )
                    }
                    className="text-[12px] font-bold px-[4px]"
                  >
                    −
                  </button>
                  <span className="text-[11px] font-semibold mx-[2px]">
                    {item.qty}
                  </span>
                  <button
                    onClick={() =>
                      setSelectedItems((prev) =>
                        prev.map((it) =>
                          it._id === item._id
                            ? { ...it, qty: it.qty + 1 }
                            : it
                        )
                      )
                    }
                    className="text-[12px] font-bold px-[4px]"
                  >
                    +
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Product Name & Price */}
          <div className="text-center">
            <p className="text-[12px] font-medium text-gray-800 line-clamp-2 leading-tight">
              {item.product_name}
            </p>
            <p className="text-[13px] font-semibold text-gray-700 mt-[3px]">
              ₹{item.selling_price?.toLocaleString("en-IN") || 0}
            </p>
          </div>

          {/* Remove Button */}
          <button
            onClick={() =>
              setSelectedItems((prev) =>
                prev.filter((it) => it._id !== item._id)
              )
            }
            className="absolute top-1 right-1 text-[11px] text-gray-400 hover:text-red-500"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  </div>
)}



      </div>

      {/* Bottom Button */}
      <div className="px-5 py-3 border-t bg-white flex justify-end">
        <button
          onClick={handleAddItems}
          className="bg-red-600 hover:bg-red-700 text-white font-medium px-5 py-2 rounded-lg shadow-md"
        >
          Save Items
        </button>
      </div>
    </div>
  </div>
)}





{showBottomSheet && (
  <div
    className="fixed inset-0 flex items-end justify-center z-50 "
    style={{ pointerEvents: "none" }} 
  >
    <div
      className="bg-white w-full max-h-[80vh] flex flex-col overflow-hidden relative border-t border-gray-300 rounded-t-2xl animate-slideUp"
      style={{
        pointerEvents: "auto", 
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        overscrollBehavior: "contain", 
      }}
    >
      {/* Handle line */}
      <div className="relative mt-2">
        <div className="absolute left-1/2 transform -translate-x-1/2 w-14 h-[4px] bg-gray-300 rounded-full"></div>
      </div>

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
        <p className="text-gray-900 text-md font-semibold">Uploaded Image(s)</p>
          <button
          onClick={() => setShowBottomSheet(false)}
          className="text-gray-400 hover:text-gray-600 text-3xl"
        >
          &times;
        </button>
      </div>

      {/* Image Container */}
      <div className="bg-gray-50 relative h-[40vh] overflow-hidden">
        {/* ✅ Scrollable Image Area */}
        <div
          className="h-full w-full overflow-y-auto flex justify-center items-start"
          style={{
            WebkitOverflowScrolling: "touch", // ✅ smooth scroll on mobile
            overscrollBehaviorY: "contain",
          }}
          onTouchStart={(e) => e.stopPropagation()} // ✅ allow inner scroll only
          onTouchMove={(e) => e.stopPropagation()}
        >
          {images.length > 0 ? (
  <img
    src={`${process.env.REACT_APP_FORE_BRICKBUCKET}${images[currentIndex]}`}
    alt="preview"
    className="transition-transform duration-300 ease-in-out object-contain"
    style={{
      transform: `scale(${zoom})`,
      cursor: zoom > 1 ? "grab" : "auto",
      maxWidth: "100%",
      height: "auto",
    }}
  />
) : (
  <div className="flex items-center justify-center w-full h-64 bg-gray-50 border border-gray-200 rounded-lg">
    <FontAwesomeIcon
      icon={faImage}
      className="text-gray-400 text-5xl"
    />
  </div>
)}

        </div>

        {/* Zoom Buttons */}
        <div className="absolute top-3 right-3 flex flex-row gap-2 z-30">
          <button
            onClick={handleZoomIn}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-md hover:scale-110 transition"
          >
            <FontAwesomeIcon icon={faSearchPlus} className="text-gray-700 text-lg" />
          </button>

          <button
            onClick={handleZoomOut}
            className="w-9 h-9 flex items-center justify-center rounded-full bg-white shadow-md hover:scale-110 transition"
          >
            <FontAwesomeIcon icon={faSearchMinus} className="text-gray-700 text-lg" />
          </button>
        </div>

        {/* Left / Right Navigation */}
        {images.length > 1 && (
          <>
            <button
              onClick={handlePrev}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/70 hover:bg-white text-gray-700 p-2 rounded-full shadow z-30"
            >
              <FontAwesomeIcon icon={faChevronLeft} className="text-lg" />
            </button>
            <button
              onClick={handleNext}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/70 hover:bg-white text-gray-700 p-2 rounded-full shadow z-30"
            >
              <FontAwesomeIcon icon={faChevronRight} className="text-lg" />
            </button>
          </>
        )}

        {/* Image Counter */}
        {images.length > 1 && (
          <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 bg-white/80 text-gray-800 text-xs px-3 py-1 rounded-full z-30 shadow">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  </div>
)}

{/* Update Item Bottom Sheet */}
 {editingItem && (
  <div className="fixed inset-0 z-50 flex justify-center items-start pt-10 bg-black/40 transition-all duration-200">
    {/* Modal Container */}
    <div
    ref={editPopupRef} 
     className="bg-white w-full mx-2 max-w-sm shadow-xl overflow-hidden animate-slide-up relative">

      {/* Header */}
      <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
        <h2 className="text-base font-semibold text-gray-900">Change Item</h2>
        <button
          onClick={handleClose}
          className="text-gray-400 hover:text-gray-600 text-3xl"
        >
          &times;
        </button>
      </div>

      {/* Search Input */}
      <div className="px-4 pt-4 pb-2">
        <div className="relative">
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
          />
          <input
            ref={inputRef}
            type="text"
            value={editingItem.name}
            onChange={handleNameChange}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setTimeout(() => setIsInputFocused(false), 200)}
            className="w-full border border-gray-300 rounded-md pl-9 pr-2 py-2 text-sm outline-none"
            placeholder="Search for a product..."
          />

          {editingItem.name && (
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleNameChange({ target: { value: "" } });
                inputRef.current?.focus();
                // Removed setShowSuggestions(true) to allow handleNameChange to close suggestions when value is empty
                setPreventSuggestions(false);
              }}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-lg leading-none"
            >
              &times;
            </button>
          )}

          {/* ✅ Suggestions remain unchanged */}
          {showSuggestions && suggestions.length > 0 && (
            <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-200 rounded shadow max-h-48 overflow-y-auto z-50">
              {suggestions.map((s) => {
                const productName = s.product_name.split(" - ")[0];
                const price = s.selling_price ?? 0;
                const imageUrl = s.product_image
                  ? `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${s.product_image}`
                  : null;
                const isAlreadyInMR = mrData?.items?.some((mrItem) => mrItem.product_id?._id === s._id);

                return (
                  <div
                    key={s._id}
                    onClick={() => {
                      if (!isAlreadyInMR) {
                        setEditingItem((prev) => ({
                          ...prev,
                          id: prev.id,
                          name: s.product_name,
                          product_id: s._id,
                          image: imageUrl,
                          price,
                          priceChanged: true,
                        }));
                        setShowSuggestions(false);
                        setPreventSuggestions(true);
                      }
                    }}
                    className={`px-3 py-2 flex items-center gap-3 border-b border-gray-100 last:border-none ${
                      isAlreadyInMR ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100 cursor-pointer"
                    }`}
                  >
                    <div className="w-10 h-10 flex-shrink-0 rounded-md overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center">
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt={productName}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                       <div className="flex flex-col items-center justify-center text-gray-400">
                       <FontAwesomeIcon icon={faImage} className="text-md" />
                     </div>
                      )}
                    </div>
                    <div className="flex-grow">
                      <p className={`font-medium text-sm ${isAlreadyInMR ? "text-gray-500" : "text-gray-800"}`}>
                        {productName}
                      </p>
                      <p className="text-xs text-gray-500">
                        ₹{price.toLocaleString("en-IN")}
                      </p>
                    </div>
                    {isAlreadyInMR ? (
                      <span className="text-xs text-red-500 font-medium">Already added</span>
                    ) : (
                      <button className="px-3 py-1 text-xs bg-red-500 text-white rounded-md hover:bg-red-600 transition">
                        Select
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Product Card - Image Left, Details Right */}
      <div className="px-4 pt-2 pb-4">
        <div className="flex items-center gap-4 border border-gray-200 rounded-xl p-3">
          
          {/* ✅ Image on Left */}
          <div className="w-20 h-20 rounded-lg overflow-hidden border border-gray-200 flex-shrink-0 bg-gray-100 flex items-center justify-center">
            {editingItem.image ? (
              <img
                src={editingItem.image}
                alt={editingItem.name}
                className="w-16 h-16 object-cover bg-gray-100"
                onError={(e) => (e.target.style.display = 'none')}
              />
            ) : (
              <FontAwesomeIcon
                icon={faImage}
                className="text-gray-400 text-2xl"
              />
            )}
          </div>

          {/* ✅ Name, Price, Quantity on Right */}
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-medium text-gray-800 break-words line-clamp-2 mb-1">
              {editingItem.name ||editingItem.originalName}
            </h3>

            <div className="flex items-center justify-between mt-3">
              <p className="text-md font-semibold text-gray-900">
                ₹{editingItem.price ?? 0}
              </p>
             <div className="flex items-center border border-gray-300 rounded-md overflow-hidden min-w-[100px] flex-shrink-0 mr-1">
  {/* Decrease Button */}
  <button
    onClick={() =>
      handleChange("qty", Math.max(0, Number(editingItem.qty || 0) - 1))
    }
    className="font-extrabold w-7 h-8 flex items-center justify-center text-red-500 text-sm"
  >
    −
  </button>

  <div className="h-6 w-px bg-gray-300"></div>

  {/* Quantity Input */}
 <input
  ref={qtyInputRef}
  type="number"
  value={editingItem.qty ?? 0}
  onFocus={() => {
    isQtyFocused.current = true;
  }}
  onBlur={() => {
    isQtyFocused.current = false;
    const cur = String(editingItem.qty ?? "");
    if (cur === "" || cur === "0") {
      if (qtyCleared.current && !hasEnteredNewQty.current) {
        setEditingItem(prev => ({ ...prev, qty: String(lastValidQty.current) }));
      } else {
       
        if (!hasEnteredNewQty.current) {
          setEditingItem(prev => ({ ...prev, qty: String(lastValidQty.current) }));
        }
      }
    } else {
      const parsed = parseInt(cur.replace(/\D/g, ""), 10) || lastValidQty.current;
      lastValidQty.current = parsed;
      setEditingItem(prev => ({ ...prev, qty: String(parsed) }));
    }
  }}
  onChange={(e) => {
    const raw = e.target.value;
    const filtered = raw.replace(/\D/g, "");

    if (filtered === "") {
      qtyCleared.current = true;
      hasEnteredNewQty.current = false;
      setEditingItem(prev => ({ ...prev, qty: "" }));
    } else {
      if (qtyCleared.current) hasEnteredNewQty.current = true;
      qtyCleared.current = false;
      setEditingItem(prev => ({ ...prev, qty: filtered }));
    }
  }}
  className="px-auto mx-auto font-bold w-7 text-center text-sm text-gray-700 border-0 bg-transparent focus:outline-none focus:ring-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
  min="0"
/>

  <div className="h-6 w-px bg-gray-300"></div>

  {/* Increase Button */}
  <button
    onClick={() =>
      handleChange("qty", Number(editingItem.qty || 0) + 1)
    }
    className="font-extrabold w-7 h-8 flex items-center justify-center text-red-500 text-sm"
  >
    +
  </button>
</div>

            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-4 flex justify-end">
          <button
            onClick={handleSave}
            className="px-6 py-2.5 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600 active:bg-red-700 transition-all shadow-sm hover:shadow-md"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{/* Bucket Warning Popup  */}
{showWarningPopup && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-end justify-center">
    <div 
    ref={warningPopupRef}
    className="bg-white rounded-t-2xl w-full max-w-md p-5 flex flex-col gap-4 shadow-lg">
      
      {/* Handle line */}
      <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mb-2"></div>

      {/* Message */}
      <p className="text-gray-700 text-sm text-center leading-snug px-3">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="text-yellow-500 text-base align-text-top mr-1"
        />
        Some items you previously added to the bucket are still present. If you
        proceed, these previous items will be removed. Do you want to continue?
      </p>

      {/* Buttons */}
      <div className="flex gap-3 justify-center mt-2">
        <button
          className="flex-1 px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 transition"
          onClick={() => setShowWarningPopup(false)}
        >
          Cancel
        </button>

        {/* ✅ Fixed Proceed Button */}
        <button
          className="flex-1 px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg transition"
          onClick={() => {
            if (!mrData || !mrData.items) return;

            // 🟢 Step 1: Filter only available items
            const availableItems = mrData.items.filter(
              (item) => item.is_available === true || item.item_available === true
            );

            if (availableItems.length === 0) {
              alert("No available items to add to the bucket.");
              setShowWarningPopup(false);
              return;
            }

            // 🟢 Step 2: Create bucketItems INSIDE this onClick
            const bucketItems = availableItems.map((item) => ({
              _id: item._id || item.id,
              product_name: item.product_name || item.product_id?.product_name || "",
              product_category_id:
                item.product_category?._id ||
                item.product_id?.product_category_id ||
                null,
              product_category_name:
                item.product_category?.product_category_name ||
                (mrData.product_category_ids.find(
                  (c) => c._id === item.product_id?.product_category_id
                )?.product_category_name ?? "") ||
                "",
              product_image:
                item.product_image ||
                item.product_id?.product_image ||
                "",
              quantity: item.quantity || item.qty || 0,
              selling_price:
                item.selling_price ||
                item.product_id?.selling_price ||
                0,
            }));

            // 🟢 Step 3: Save to localStorage
            localStorage.setItem("bucketProducts", JSON.stringify(bucketItems));

            // 🟢 Step 4: Close popup & navigate
            setShowWarningPopup(false);
            window.location.href = "/consumer/cartpreview";
          }}
        >
          Proceed
        </button>
      </div>
    </div>
  </div>
)}

{showDeletePopup && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-end justify-center">
    <div
    ref={deletePopupRef}
     className="bg-white rounded-t-2xl w-full max-w-md p-5 flex flex-col gap-4 shadow-lg">
      <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mb-2"></div>
      <p className="text-gray-700 text-sm text-center leading-snug px-3">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="text-yellow-500 text-base align-text-top mr-1"
        />
        Are you sure you want to delete this item? This action cannot be undone.
      </p>
      <div className="flex gap-3 justify-center mt-2">
        <button
          className="flex-1 px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100 transition"
          onClick={() => {
            setShowDeletePopup(false);
            setItemToDelete(null);
          }}
        >
          Cancel
        </button>
        <button
          className="flex-1 px-4 py-2 text-sm bg-red-600 hover:bg-red-700 text-white rounded-lg transition"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default ReviewItemList;
